import { getConsentStatus } from "./cookieConsent";

let activeAnalytics = null;

const configuredProvider = () =>
  import.meta.env.VITE_ANALYTICS_PROVIDER?.trim().toLowerCase() || "self-hosted";

const configuredGoogleMeasurementId = () =>
  import.meta.env.VITE_GOOGLE_ANALYTICS_ID?.trim() || "";

export function initializeHostedAnalytics({
  provider = configuredProvider(),
  googleMeasurementId = configuredGoogleMeasurementId(),
} = {}) {
  if (activeAnalytics) return shutdownHostedAnalytics;
  if (typeof window === "undefined" || typeof document === "undefined") {
    return shutdownHostedAnalytics;
  }
  if (getConsentStatus() !== "accepted") return shutdownHostedAnalytics;
  if (provider !== "google" || !/^G-[A-Z0-9]+$/i.test(googleMeasurementId)) {
    return shutdownHostedAnalytics;
  }

  const dataLayer = window.dataLayer || [];
  const ownsDataLayer = !window.dataLayer;
  const gtag =
    window.gtag ||
    function gtag() {
      dataLayer.push(arguments);
    };
  const ownsGtag = !window.gtag;

  window.dataLayer = dataLayer;
  window.gtag = gtag;
  window[`ga-disable-${googleMeasurementId}`] = false;

  gtag("js", new Date());
  gtag("config", googleMeasurementId, { anonymize_ip: true });

  const scriptSelector = `script[data-nexus-analytics="google"][data-measurement-id="${googleMeasurementId}"]`;
  let script = document.querySelector(scriptSelector);
  const ownsScript = !script;
  if (!script) {
    script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(googleMeasurementId)}`;
    script.dataset.nexusAnalytics = "google";
    script.dataset.measurementId = googleMeasurementId;
    document.head.appendChild(script);
  }

  activeAnalytics = {
    dataLayer,
    googleMeasurementId,
    gtag,
    ownsDataLayer,
    ownsGtag,
    ownsScript,
    script,
  };
  return shutdownHostedAnalytics;
}

export function shutdownHostedAnalytics() {
  if (!activeAnalytics) return;

  const analytics = activeAnalytics;
  activeAnalytics = null;
  window[`ga-disable-${analytics.googleMeasurementId}`] = true;

  if (analytics.ownsScript) {
    analytics.script.remove();
  }
  if (analytics.ownsGtag && window.gtag === analytics.gtag) {
    delete window.gtag;
  }
  if (analytics.ownsDataLayer && window.dataLayer === analytics.dataLayer) {
    delete window.dataLayer;
  }
}
